import {
  BulkPublishResult,
  CreateDraftRequest,
  DraftTimelog,
  PublishDraftResult,
  TrackerQueue,
  UpdateDraftRequest,
} from '@/types';

import { apiUrls } from './apiUrls';
import { createApiInstance } from './createApiInstance';
import { ItemResponse, ItemsResponse } from './types';

class DraftTimelogsApi {
  private axiosInstance = createApiInstance('draft-timelogs');

  async list(params: { dateFrom?: string; dateTo?: string } = {}): Promise<DraftTimelog[]> {
    const response = await this.axiosInstance.get<ItemsResponse<DraftTimelog>>(
      apiUrls.draftTimelogs.list,
      {
        params,
      },
    );

    return response.data.items;
  }

  async create(data: CreateDraftRequest): Promise<DraftTimelog> {
    const response = await this.axiosInstance.post<ItemResponse<DraftTimelog>>(
      apiUrls.draftTimelogs.create,
      data,
    );

    return response.data.item;
  }

  async update(id: string, data: UpdateDraftRequest): Promise<DraftTimelog> {
    const response = await this.axiosInstance.put<ItemResponse<DraftTimelog>>(
      apiUrls.draftTimelogs.update(id),
      data,
    );

    return response.data.item;
  }

  async remove(id: string): Promise<void> {
    await this.axiosInstance.delete(apiUrls.draftTimelogs.delete(id));
  }

  async publish(id: string): Promise<PublishDraftResult> {
    const response = await this.axiosInstance.post<ItemResponse<PublishDraftResult>>(
      apiUrls.draftTimelogs.publish(id),
    );

    return response.data.item;
  }

  async publishBulk(data: { dateFrom: string; dateTo: string }): Promise<BulkPublishResult> {
    const response = await this.axiosInstance.post<ItemResponse<BulkPublishResult>>(
      apiUrls.draftTimelogs.publishBulk,
      data,
    );

    return response.data.item;
  }

  async suggestQueues(query: string, signal?: AbortSignal): Promise<TrackerQueue[]> {
    const response = await this.axiosInstance.get<ItemsResponse<TrackerQueue>>(
      apiUrls.queues.suggest,
      {
        params: { query },
        signal,
      },
    );

    return response.data.items;
  }
}

export const draftTimelogsApi = new DraftTimelogsApi();
